export const EXECUTIVE_SUMMARY_IMPRESSION_TYPES = [
  'overview',
  'heart',
  'cancer',
  'brain',
  'musculoskeletal',
  'metabolic',
  'functional-biomarker-profile',
] as const;

export type ExecutiveSummaryImpressionType =
  (typeof EXECUTIVE_SUMMARY_IMPRESSION_TYPES)[number];
